module.exports = __webpack_public_path__ + "letterFadeUnrollInTop.gif";